<template>
  <footer class="mt-auto footer">
    <div class="primary lighten-1 pb-6 pb-md-8 pb-lg-11">
      <v-container>
        <v-row
          align="center"
          justify="center"
          justify-lg="space-around"
          no-gutters
        >
          <v-col
            class="pt-6 pt-md-8 pt-lg-11"
            cols="12"
            md="4"
            lg="3"
            v-if="informations.address"
          >
            <div class="d-flex justify-center flex-column text-center">
              <v-btn
                :href="informations.google_maps"
                target="_blank"
                width="43px"
                rounded
                color="white"
                height="44px"
                class="mx-auto btn-info"
                icon
              >
                <v-icon size="20"> fa fa-map-marker-alt </v-icon>
              </v-btn>

              <div class="secondary--text text-h6 font-weight-bold mt-2">
                Localização
              </div>

              <div class="white--text text-h6 font-weight-regular mt-2">
                {{ informations.address }}
              </div>
            </div>
          </v-col>

          <v-col
            class="pt-6 pt-md-8 pt-lg-11"
            cols="12"
            md="4"
            lg="3"
            v-if="informations.office_hours"
          >
            <div class="d-flex justify-center flex-column text-center">
              <v-btn
                width="43px"
                rounded
                color="white"
                height="44px"
                class="mx-auto btn-info"
                icon
              >
                <v-icon size="20"> fa fa-clock </v-icon>
              </v-btn>

              <div class="secondary--text text-h6 font-weight-bold mt-2">
                Horário de atendimento
              </div>

              <div class="white--text text-h6 font-weight-regular mt-2">
                {{ informations.office_hours }}
              </div>
            </div>
          </v-col>

          <v-col
            class="pt-6 pt-md-8 pt-lg-11"
            cols="12"
            md="4"
            lg="3"
            v-if="informations.tel || informations.email"
          >
            <div class="d-flex justify-center flex-column text-center">
              <v-btn
                :href="telToLink(informations.tel)"
                color="white"
                class="mx-auto btn-info"
                height="44px"
                icon
                target="_blank"
                rounded
                width="43px"
              >
                <v-icon size="20"> fa fa-phone-alt </v-icon>
              </v-btn>

              <div class="secondary--text text-h6 font-weight-bold mt-2">
                Entre em contato
              </div>

              <div class="white--text text-h6 font-weight-regular mt-2">
                <div v-if="informations.tel">
                  <a
                    class="white--text text-decoration-none"
                    :href="telToLink(informations.tel)"
                    target="_blank"
                  >
                    {{ informations.tel }}
                  </a>
                </div>
                <div v-if="informations.email">
                  <a
                    class="white--text text-decoration-none"
                    :href="`mailto:${informations.email}`"
                  >
                    {{ informations.email }}
                  </a>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-sheet
      color="primary"
      width="100%"
      min-height="64px"
      class="d-flex align-center"
    >
      <v-container>
        <div
          class="
            d-flex
            align-center
            justify-center
            flex-column flex-sm-row
            justify-sm-space-between
          "
        >
          <div class="white--text text-center py-2 copyright">
            <b>{{ informations.name }}</b>
            {{ `@ ${year} Todos os direitos reservados.` }}
          </div>

          <div class="py-2 mrx">
            <a href="https://mrxweb.com.br/" target="_blank">
              <img
                class="d-block"
                src="/img/mrxweb.svg"
                height="20px"
                alt="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
                title="MRX Web Sites, Publicidade, Marketing Digital, Produção de Vídeos - Sinop/MT"
              />
            </a>
          </div>
        </div>
      </v-container>
    </v-sheet>
  </footer>
</template>

<script>
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";

export default {
  data: () => ({
    year: new Date().getFullYear(),
  }),
  computed: {
    informations() {
      if (!this.$rest(`informations`).item) return "";
      return this.$rest(`informations`).item;
    },
  },
  methods: {
    telToLink(num) {
      return getWhatsappLinkFromPhone(num);
    },
    showPrivacy: () => window.showPrivacyPolicy(),
  },
};
</script>

<style lang="scss" scoped>
.footer {
  .btn-info {
    background-color: rgba(255, 255, 255, 0.2);
  }
}
</style>
